import { LogLevel } from "@azure/msal-browser";
import { Environment } from "../interfaces/Environment";

export const environment: Environment = {
    production: true,
    msal: {
        auth: {
            clientId: "e8684fa0-34c7-4551-a8b3-3deb95152033",
            authority: "https://login.microsoftonline.com/372ee9e0-9ce0-4033-a64a-c07073a91ecd",
            redirectUri: "https://firstaiders.pl.abb.com",
        },
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: false, // set to "true" if issues on IE11/Edge
        },
        system: {
            loggerOptions: {
                loggerCallback: (level: LogLevel, message: string, containsPii: any) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            return;
                        case LogLevel.Info:
                            console.info(message);
                            return;
                        case LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            return;
                        default:
                            return;
                    }
                }
            }
        }
    },
    api: {
        getAvailableFAInfoAndChatName: "https://prod-76.westeurope.logic.azure.com:443/workflows/ad6ca694f58b4ae684dbc292180a8a30/triggers/manual/paths/invoke?api-version=2016-10-01",
        callForHelp: "https://prod-138.westeurope.logic.azure.com:443/workflows/738112d7426f4debb6d94971b1d43d6c/triggers/manual/paths/invoke?api-version=2016-10-01",
        cancelCallForHelp: "https://prod-20.westeurope.logic.azure.com:443/workflows/54208a82e89347f8a34204ba50124f72/triggers/manual/paths/invoke?api-version=2016-10-01",
        HC: "https://prod-122.westeurope.logic.azure.com:443/workflows/51e1bedb148146978ba3d76a45009a6c/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=bioGZNTX-YH7VULaMLqikXWXQTwwxxEl-fw8jiHTZk8"
    },
    storageInformation: {
        accountName: 'firstaidersprodstorage',
        tableName: 'firstAidersList',
    },
    serviceAccountId: "78007fca-6c22-4424-a4ca-eb6af032d37b"
}